/* BF VIP offers (sections/vip-offers.liquid): picking an offer updates the summary bar and button text. */
if (!customElements.get('nanobag-vip-landing-offers')) {
  customElements.define('nanobag-vip-landing-offers', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const update = () => {
        const selected = this.querySelector('.nbvo-deal-choice:checked');
        const card = selected?.closest('[data-offer]');
        if (!card) return;
        this.querySelector('[data-summary-title]').textContent = card.dataset.title;
        this.querySelector('[data-summary-details]').textContent = card.dataset.details;
        this.querySelector('[data-shop-link]').textContent = card.dataset.cta;
      };
      this.addEventListener('change', event => {
        if (event.target.matches('.nbvo-deal-choice')) update();
      }, {signal});
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-shop-link]');
        const hash = link?.getAttribute('href') || '';
        if (hash.charAt(0) !== '#' || hash.length < 2) return;
        const id = decodeURIComponent(hash.slice(1));
        const target = document.getElementById(id)
          || document.getElementById('shopify-section-' + id)
          || document.querySelector('[id^="shopify-section-"][id$="__' + CSS.escape(id) + '"]');
        if (!target) return;
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({behavior: reduced ? 'auto' : 'smooth', block: 'start'});
        history.replaceState?.(null, '', '#' + id);
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const card = Array.from(this.querySelectorAll('[data-block-id]')).find(item => item.dataset.blockId === event.detail.blockId);
        if (card) {card.querySelector('.nbvo-deal-choice').checked = true; update();}
      }, {signal});
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, {once: true, signal});
      else update();
    }
    disconnectedCallback() {this.abort?.abort();}
  });
}
